var scope_0 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/144e2e66f44809a9f3b8b039ea45fda8.js').default;

var scope_1 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1ad3d025e9dba199d835fec14f508f5a.js').default;

var scope_2 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b4a0fb29070057833570e4028a8240b.js').default;

var scope_3 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/295fc202db35c09383bf49bbed531e42.js').default;

var scope_4 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/321f853cf64a586a8e2a069e27c76a2b.js').default;

var scope_5 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/323cb47ed8e56bcef69e9c278b66d593.js').default;

var scope_6 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3e03dbfc5f3d40c0296946fcb358f941.js').default;

var scope_7 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4470c67efdee5fabae738672dafd2582.js').default;

var scope_8 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5e0838ec6b43196d1d5851295a6a8739.js').default;

var scope_9 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5e7e591b0ba602effb1ab7ba2f252e03.js').default;

var scope_10 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6752f065eff63394648b01d2d22423e0.js').default;

var scope_11 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6da746db7c5a6a087c194c2deb00e2a4.js').default;

var scope_12 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6dca282f262aa6e5f66589267be3d408.js').default;

var scope_13 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7c73f7c242cb2713ab71f111cf14dc0c.js').default;

var scope_14 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf16b4e0a8de37eb6993dd4b90ac6eef.js').default;

var scope_15 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf39aaea6d62faef6d83c29ae2dbd0d3.js').default;

var scope_16 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d18aac22e6aaae6becb85d32641484de.js').default;

var scope_17 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d8203fc6a817818cb11cebdb69762fd2.js').default;

var scope_18 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_19 = require('/var/jenkins_home/workspace/TexasMassageInfo-Prod/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f3574713cc4802f5dfaff97d252e15c0.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18, scope_19);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}